<div *ngIf="filterNav?.refinementType === 'StaticRefinementMenu'">
  <app-usf-expandable-panel title="{{ filterNav.displayName }}">
    <div class="refinement-section">
      <li
        [attr.data-cy]="'static-refinement-menu-' + x + '-li'"
        *ngFor="let filter of filterNav.staticRefinements; let x = index"
        class="row ml-1 mr-0"
      >
        <div class="form-check custom-checkbox pb-1">
          <input
            [attr.data-cy]="'static-refinement-menu-' + x + '-input-checkbox'"
            type="checkbox"
            class="form-check-input custom-control-input"
            [checked]="filter.selected === true"
            name="chkboxBrands"
            id="{{ filter.selectedFilter }}"
          />
          <label
            for="{{ filter.selectedFilter }}"
            [attr.data-cy]="'static-refinement-menu-' + x + '-the-scoop-label'"
            class="form-check-label custom-control-label"
            *ngIf="filter.displayName === 'The Scoop'"
            title="The Scoop&trade;"
          >
            The Scoop&trade;
          </label>
          <label
            for="{{ filter.selectedFilter }}"
            class="form-check-label custom-control-label"
            [attr.data-cy]="'static-refinement-menu-' + x + '-label'"
            *ngIf="filter.displayName !== 'The Scoop' && filter.count !== 0"
            title="{{ filter.displayName | titlecase }}"
          >
            {{ filter.displayName | titlecase }} ({{ filter.count }})
          </label>
        </div>
      </li>
    </div>
  </app-usf-expandable-panel>
</div>
